import _ from "lodash";
import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {activeCompanyIdAtom} from "./activeCompanyStore";
import {Field} from "../types/domain/field";
import {getAllFields} from "../services/fieldService";
import {OrderStatus} from "../types/domain/orderStatus";
import {showActiveFieldsAtom} from "./filterSelectionStore";

export const activeCompanyFieldsAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    const activeFieldFilter = get(showActiveFieldsAtom);

    let allFields: Field[] = [];
    if (activeCompanyId) {
        allFields = await getAllFields({companyId: activeCompanyId});
        if (activeFieldFilter) {
            const newFields = allFields.filter((item) => {
                if (item.order) {
                    return item.order.state === OrderStatus.ACTIVE;
                }
                return false;
            });
            allFields = newFields;
        }
    }

    return {
        fields: allFields,
        mapByFarmId: _.groupBy(allFields, "farmId"),
        mapByOrderId: _.groupBy(allFields, "orderId"),
        mapByFieldId: _.keyBy(allFields, "id"),
    };
});
activeCompanyFieldsAtom.debugLabel = "activeCompanyFields";

export const activeCompanyFieldsLoadable = loadable(activeCompanyFieldsAtom);
